// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"TicketRecordList--next-sr-only--14bmsuT","pageContent":"TicketRecordList--pageContent--2_U-KUc"};